import { combineReducers } from 'redux';

import * as types from '../actions/ActionTypes';
import WordingService from '../services/WordingService';

const initialState = {
  otc: {
    value: '',
    receivedAt: Date.now(),
  },
  otcError: {
    valid: true,
    errorMessage: '',
  },
};

export const otc = (state = initialState.otc, action) => {
  switch (action.type) {
    case types.CREATE_OTP_SUCCESS:
    case types.RETRY_OTC_SUCCESS:
      return {
        value: action.payload.otc,
        receivedAt: action.receivedAt,
      };
    default:
      return state;
  }
};

export const otcError = (state = initialState.otcError, action) => {
  switch (action.type) {
    case types.CLEAR_INPUT_ERROR:
      if (action.payload.field === 'otc') {
        return initialState.otcError;
      }
      return state;
    case types.SET_INPUT_ERROR:
      if (action.payload.field === 'otc') {
        switch (action.payload.error) {
          case 'empty':
            return {
              valid: false,
              errorMessage: WordingService.getWording('errorMessage', 'noOtpInput'),
            };
          case 'nan':
            return {
              valid: false,
              errorMessage: WordingService.getWording('errorMessage', 'otpIsNotANumber'),
            };
          case 'incorrect':
            return {
              valid: false,
              errorMessage: WordingService.getWording('errorMessage', 'otpIsIncorrect'),
            };
          default:
            return state;
        }
      }
      return state;
    default:
      return state;
  }
};

export default combineReducers({
  otc,
  otcError,
});
